// https://github.com/mantinedev/mantine/blob/master/src/mantine-styles/src/theme/utils/rem/rem.ts
// https://mantine.dev/styles/rem/
function createConverter(units) {
    return function (px) {
        if (typeof px === 'number') {
            return "".concat(px / 16).concat(units);
        }
        if (typeof px === 'string') {
            var replaced = px.replace('px', '');
            if (!Number.isNaN(Number(replaced))) {
                return "".concat(Number(replaced) / 16).concat(units);
            }
        }
        return px;
    };
}
/**
 * Converts px to rem with base font size 16px. If value is not a number or string with px units, returns value as is.
 * @param px - px value to convert (number or string with px units)
 * @example rem(32); // -> '2rem'
 * @example rem('16px'); // -> '1rem'
 * @returns rem value as a string
 */
export var rem = createConverter('rem');
/**
 * Converts px to rem. If value is not a number or string with px units, returns value as is.
 * @param px - px value to convert (number or string with px units)
 * @example em(32); // -> '2rem'
 * @example em('16px'); // -> '1rem'
 * @returns rem value as a string
 */
export var em = createConverter('em');
